import { render } from "./NumberComponent.vue?vue&type=template&id=fbc049f4&ts=true"
import script from "./NumberComponent.vue?vue&type=script&lang=ts"
export * from "./NumberComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__